import React from "react";
import classes from "./SimulationChooser.module.sass";
import Button from "../ui/Button/Button";

import Title from "../../components/Title/Title";
import gaTags from "../../utils/ga-tags"
import {simulationType} from "../../containers/Products/Products";

class SimulationChooser extends React.Component {
  targetDiv = React.createRef();

  scrollToDiv = () => {
    this.targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
  };




  render() {

    const product = this.props.selectedProduct.id === "1" ? 'Imóvel' : 'Veículo';
    const gaTypeName = `${gaTags.type}Parcela&Total-`

    return (
      <div
        ref={el => {
          this.targetDiv = el;
        }}
        className={classes.simulationChooser}
      >
        <Title title=" Você prefere fazer a simulação:" />

        <div className={classes.listButtons}>
          <Button
            onClick={() => this.props.simulationClicked(simulationType.PARCELA)}
            selected={this.props.selectedSimulation === simulationType.PARCELA}
            data-gacategory={gaTags.categoryDefault}
            data-gatype={`${gaTypeName}${product}`}
            data-gafunc={`${gaTypeName}${product}-ValorParcela`}>
            Pelo valor da parcela
          </Button>
          <Button
            onClick={() => this.props.simulationClicked(simulationType.CREDITO)}
            selected={this.props.selectedSimulation === simulationType.CREDITO}
            data-gacategory={gaTags.categoryDefault}
            data-gatype={`${gaTypeName}${product}`}
            data-gafunc={`${gaTypeName}${product}-ValorCrédito`}>
            Pelo valor total do crédito
          </Button>
        </div>
      </div>
    );
  }
}
export default SimulationChooser;
